<div class="c-form-field c-form-field--select" [ngClass]="cssClass">
  <ng-select class="c-form-field__input" [formControl]="control" [placeholder]="placeholder" [clearable]="false">
    <ng-option *ngFor="let opt of data | keyvalue: orderFn" [value]="opt.key">
      <img width="24" height="24" *ngIf="opt.value.img" [src]="opt.value.img" />
      <span>{{ opt.value.name }}</span>
    </ng-option>
  </ng-select>
  <div class="c-form-field__label">{{ label }}</div>
  <div class="c-form-field__msg -error" *ngIf="errorText">{{ errorText }}</div>
</div>
